// import React, { useEffect, useState } from 'react';
// import { handleMembershipInputChange } from "../../redux/slices/billSlice";


// const MembershipCard = ({ data, state, dispatch, onClose, handleUpdateServices }) => {
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [activeTab, setActiveTab] = useState(0);
//   const [selectedType, setSelectedType] = useState(null);
//   const [serviceSelections, setServiceSelections] = useState({});

//   const memberships = Array.isArray(data) ? data : [data];
//   const hasServiceMembership = memberships.some(m => m.membershipType === 'serviceType');
//   const hasDiscountMembership = memberships.some(m => m.membershipType === 'discountType');

//   // Initialize selected services and service selections
//   const filteredMemberships = selectedType
//     ? memberships.filter(m => m.membershipType === selectedType)
//     : [];
   
//   useEffect(() => {
//     if (selectedType === 'serviceType') {
//       const servicesInBill = new Set(state.services.map(s => s.service));
//       const initialSelections = {};
//       let allSelected = [];

//       memberships.forEach((membership, tabIndex) => {
//         if (membership.membershipType === 'serviceType' && membership.services) {
//           initialSelections[tabIndex] = membership.services
//             .filter(service => servicesInBill.has(service.id))
//             .map(service => service.id);

//           membership.services.forEach(service => {
//             if (servicesInBill.has(service.id) && !allSelected.some(s => s.id === service.id)) {
//               allSelected.push(service);
//             }
//           });
//         }
//       });

//       setServiceSelections({});
//       setSelectedServices([]);
//     }
//   }, [selectedType, memberships, state.services]);

//   const handleCheckboxChange = (service, tabIndex) => {
//     const isSelected = serviceSelections[tabIndex]?.includes(service.id) || false;

//     setServiceSelections(prev => {
//       const newSelections = { ...prev };
//       if (!newSelections[tabIndex]) newSelections[tabIndex] = [];

//       if (isSelected) {
//         newSelections[tabIndex] = newSelections[tabIndex].filter(id => id !== service.id);
//       } else {
//         newSelections[tabIndex] = [...newSelections[tabIndex], service.id];
//       }
//       return newSelections;
//     });

//     setSelectedServices(prev => {
//       if (isSelected) {
//         return prev.filter(item => item.id !== service.id);
//       } else {
//         const alreadyExists = prev.some(item => item.id === service.id);
//         if (alreadyExists) return prev;
//         return [...prev, service];
//       }
//     });
//   };

//   const applyHandler = () => {
//     if (selectedType === 'discountType') {
//       const activeMembership = memberships.find(m =>
//         m.membershipType === 'discountType' && m._id === filteredMemberships[activeTab]?._id
//       );
//       console.log(activeMembership, 'activeMembership')
//       if (activeMembership) {
//         dispatch(handleMembershipInputChange({
//           useMembership: true,
//           item: activeMembership,
//           selectedServices: [],
//           membershipUniqueId: [activeMembership.membershipId]
//         }));
//       }
//     } else {
//       // First get the active membership
//       const activeMembership = filteredMemberships[activeTab];

//       const updatedServices = selectedServices.map(service => {
//         const matchedMembership = memberships.find(m =>
//           m.membershipType === 'serviceType' &&
//           m.services?.some(s => s.id === service.id)
//         );

//         return {
//           serviceName: service.serviceName,
//           service: service.id,
//           category: service.category,
//           quantity: 1,
//           serviceProvider: [],
//           price: service.price,
//           discount: 100,
//           discountType: '%',
//           amount: 0,
//           membershipApplied: true,
//           membershipUniqueId: matchedMembership?.membershipId || null,
//         };
//       });



//       const uniqueMembershipIds = [...new Set(
//         selectedServices.map(service => {
//           const matchedMembership = memberships.find(m =>
//             m.membershipType === 'serviceType' &&
//             m.services?.some(s => s.id === service.id)
//           );
//           return matchedMembership?.membershipId;
//         }).filter(Boolean)
//       )];

//       console.log(uniqueMembershipIds, 'uniqueMembershipIds')
//       if (activeMembership) {
//         dispatch(handleMembershipInputChange({
//           useMembership: true,
//           item: activeMembership,
//           selectedServices: updatedServices,
//           membershipUniqueId: uniqueMembershipIds
//         }));
//         handleUpdateServices(updatedServices);
//       }
//     }
//     onClose();
//   };

//   console.log(state, 'stateeeeee')
//   const removeHandler = () => {
//     dispatch(handleMembershipInputChange({
//       useMembership: false,
//       item: null,
//       selectedServices: []
//     }));
//     onClose();
//   };

//   const isServiceDisabled = (service) => {
//     return service.count === 0;
//   };

//   const calculateSubTotal = () => {
//     return state.services.reduce((total, item) => total + (item.price * item.quantity), 0) +
//       state.products.reduce((total, item) => total + (item.price * item.quantity), 0);
//   };

//   const currentSubTotal = calculateSubTotal();
//   const activeMembership = filteredMemberships[activeTab];

//   const canApplyDiscount = activeMembership?.membershipType === 'discountType' &&
//     currentSubTotal >= (activeMembership?.discount?.minBillAmount || 0) &&
//     (activeMembership?.discount?.availableCount || 0) > 0;

//   const isMembershipExpired = activeMembership?.endDate &&
//     new Date(activeMembership.endDate) < new Date();

//   // Calculate selected services count per tab
//   const getSelectedCountForTab = (tabIndex) => {
//     return serviceSelections[tabIndex]?.length || 0;
//   };

//   // Calculate dynamic width based on view state
//   const containerWidth = !selectedType ? '250px' : '500px';
//   const containerHeight = !selectedType ? '230px' : 'auto';

//      // Format date to DD-MM-YYYY
//   const formatDate = (dateString) => {
//     if (!dateString) return '';
//     const [year, month, day] = dateString.split('-');
//     return `${day}-${month}-${year}`;
//   };

//   return (
//     <div style={{
//       ...styles.container,
//       width: containerWidth,
//       minHeight: containerHeight,
//       maxHeight: selectedType ? '80vh' : '200px'
//     }}>
//       <div style={styles.header}>
//         {selectedType && (
//           <button onClick={() => setSelectedType(null)} style={styles.backButton}>
//             ← Back
//           </button>
//         )}
//         <h2 style={styles.title}>Membership Card</h2>
//       </div>

//       {!selectedType ? (
//         <div style={styles.membershipTypeSelection}>
//           {hasServiceMembership && (
//             <button
//               style={styles.membershipButton}
//               onClick={() => setSelectedType('serviceType')}
//             >
//               Service Membership
//             </button>
//           )}

//           {hasDiscountMembership && (
//             <button
//               style={{
//                 ...styles.membershipButton,
//               }}
//               onClick={() => setSelectedType('discountType')}
//             >
//               Discount Membership
//             </button>
//           )}
//         </div>
//       ) : (
//         <div style={styles.membershipContent}>
//           {filteredMemberships.length > 1 && (
//             <div style={styles.tabContainer}>
//               {filteredMemberships.map((membership, index) => (
//                 <button
//                   key={membership._id}
//                   style={{
//                     ...styles.tabButton,
//                     ...(activeTab === index && styles.activeTab)
//                   }}
//                   onClick={() => setActiveTab(index)}
//                 >
//                   Membership {index + 1}
//                   {selectedType === 'serviceType' && getSelectedCountForTab(index) > 0 && (
//                     <span style={styles.badge}>
//                       {getSelectedCountForTab(index)}
//                     </span>
//                   )}
//                 </button>
//               ))}
//             </div>
//           )}

//           <div style={styles.detailsContainer}>
//             <div style={styles.detailRow}>
//               <span style={styles.detailLabel}>Type:</span>
//               <span>{activeMembership?.membershipType}</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.detailLabel}>Valid Until:</span>
//               <span style={isMembershipExpired ? styles.expiredText : {}}>
//                 {formatDate(activeMembership?.endDate)}
//                 {isMembershipExpired && " (Expired)"}
//               </span>
//             </div>

//             {selectedType === 'discountType' ? (
//               <>
//                 <div style={styles.detailRow}>
//                   <span style={styles.detailLabel}>Min. Bill Amount:</span>
//                   <span>₹{activeMembership?.discount?.minBillAmount || 0}</span>
//                 </div>
//                 <div style={styles.detailRow}>
//                   <span style={styles.detailLabel}>Service Discount:</span>
//                   <span>
//                     {activeMembership?.discount?.discountOnService || 0}
//                     {activeMembership?.discount?.serviceDiscountType || ''}
//                   </span>
//                 </div>
//                 <div style={styles.detailRow}>
//                   <span style={styles.detailLabel}>Remaining Count:</span>
//                   <span>{activeMembership?.discount?.availableCount || 0}</span>
//                 </div>
//               </>
//             ) : (
//               <div style={styles.servicesContainer}>
//                 <div style={styles.tableHeader}>
//                   <div style={{ ...styles.tableCell, flex: 0.5 }}>Select</div>
//                   <div style={styles.tableCell}>Service</div>
//                   <div style={styles.tableCell}>Category</div>
//                   <div style={styles.tableCell}>Remaining</div>
//                 </div>
//                 <div style={styles.servicesTable}>
//                   {activeMembership?.services?.map(service => (
//                     <div
//                       key={service.id}
//                       style={{
//                         ...styles.tableRow,
//                         ...(isServiceDisabled(service) && styles.disabledRow),
//                         ...(serviceSelections[activeTab]?.includes(service.id) && styles.selectedRow)
//                       }}
//                     >
//                       <div style={{ ...styles.tableCell, flex: 0.5 }}>
//                         <input
//                           type="checkbox"
//                           checked={serviceSelections[activeTab]?.includes(service.id) || false}
//                           onChange={() => handleCheckboxChange(service, activeTab)}
//                           disabled={isServiceDisabled(service)}
//                           style={styles.checkbox}
//                         />
//                       </div>
//                       <div style={styles.tableCell}>{service.serviceName}</div>
//                       <div style={styles.tableCell}>{service.category}</div>
//                       <div style={styles.tableCell}>
//                         {service.count > 0 ? service.count : (
//                           <span style={styles.zeroCount}>0</span>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>

//           <div style={styles.actionContainer}>
//             {isMembershipExpired ? (
//               <div style={styles.errorMessage}>This membership has expired</div>
//             ) : selectedType === 'discountType' ? (
//               !canApplyDiscount ? (
//                 <div style={styles.errorMessage}>
//                   {activeMembership?.discount?.availableCount === 0 ? (
//                     "Count is not available"
//                   ) : (
//                     `Add ₹${activeMembership?.discount?.minBillAmount - currentSubTotal} more to apply`
//                   )}
//                 </div>
//               ) : (
//                 <button style={styles.applyButton} onClick={applyHandler}>
//                   Apply Discount
//                 </button>
//               )
//             ) : (
//               selectedServices.length > 0 ? (
//                 <button style={styles.applyButton} onClick={applyHandler}>
//                   Apply {selectedServices.length} Service{selectedServices.length !== 1 ? 's' : ''}
//                 </button>
//               ) : (
//                 <div style={styles.errorMessage}>
//                   {activeMembership?.services?.some(s => s.count > 0)
//                     ? "Select services to apply"
//                     : "No available services in this membership"}
//                 </div>
//               )
//             )}

//             {state.useMembership && (
//               <button style={styles.removeButton} onClick={removeHandler}>
//                 Remove Membership
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: 'flex',
//     flexDirection: 'column',
//     padding: '20px',
//     borderRadius: '10px',
//     backgroundColor: '#fff',
//     boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//     overflow: 'hidden',
//     transition: 'all 0.3s ease'
//   },
//   header: {
//     display: 'flex',
//     alignItems: 'center',
//     marginBottom: '20px',
//     paddingBottom: '10px',
//     borderBottom: '1px solid #eee',
//     position: 'relative',
//   },
//   backButton: {
//     background: 'none',
//     border: 'none',
//     color: '#6174DD',
//     fontSize: '16px',
//     cursor: 'pointer',
//     padding: '5px 10px',
//     marginRight: '10px',
//   },
//   title: {
//     margin: 0,
//     color: '#333',
//     fontSize: '1.5rem',
//   },
//   membershipTypeSelection: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '15px',
//     padding: '20px 0',
//   },
//   membershipButton: {
//     padding: '15px',
//     borderRadius: '8px',
//     border: 'none',
//     backgroundColor: '#6174DD',
//     color: 'white',
//     fontSize: '16px',
//     cursor: 'pointer',
//     transition: 'all 0.2s',
//     position: 'relative',
//     textAlign: 'center',
//     '&:hover': {
//       backgroundColor: '#4a5bc7',
//     },
//   },
//   membershipContent: {
//     display: 'flex',
//     flexDirection: 'column',
//     flex: 1,
//     overflow: 'hidden',
//   },
//   tabContainer: {
//     display: 'flex',
//     gap: '5px',
//     marginBottom: '15px',
//     overflowX: 'auto',
//     padding: '5px 0',
//     scrollbarWidth: 'thin',
//     '&::-webkit-scrollbar': {
//       height: '4px',
//     },
//     '&::-webkit-scrollbar-thumb': {
//       backgroundColor: '#6174DD',
//       borderRadius: '2px',
//     },
//   },
//   tabButton: {
//     padding: '8px 15px',
//     borderRadius: '5px',
//     border: '1px solid #ddd',
//     backgroundColor: '#f5f5f5',
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
//     fontSize: '14px',
//     position: 'relative',
//   },
//   activeTab: {
//     backgroundColor: '#6174DD',
//     color: 'white',
//     borderColor: '#6174DD',
//   },
//   badge: {
//     position: 'absolute',
//     top: '-8px',
//     right: '-8px',
//     backgroundColor: '#ff4444',
//     color: 'white',
//     borderRadius: '50%',
//     width: '18px',
//     height: '18px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '10px',
//   },
//   detailsContainer: {
//     flex: 1,
//     overflow: 'hidden',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   servicesContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     flex: 1,
//     overflow: 'hidden',
//     marginTop: '15px',
//     border: '1px solid #eee',
//     borderRadius: '8px',
//   },
//   tableHeader: {
//     display: 'flex',
//     backgroundColor: '#6174DD',
//     color: 'white',
//     padding: '12px 10px',
//     fontWeight: '600',
//     position: 'sticky',
//     top: 0,
//     zIndex: 1,
//   },
//   servicesTable: {
//     flex: 1,
//     overflowY: 'auto',
//     scrollbarWidth: 'thin',
//     '&::-webkit-scrollbar': {
//       width: '6px',
//     },
//     '&::-webkit-scrollbar-thumb': {
//       backgroundColor: '#6174DD',
//       borderRadius: '3px',
//     },
//   },
//   tableRow: {
//     display: 'flex',
//     padding: '12px 10px',
//     borderBottom: '1px solid #eee',
//     cursor: 'pointer',
//     transition: 'background-color 0.2s',
//     '&:hover': {
//       backgroundColor: '#f9f9f9',
//     },
//   },
//   selectedRow: {
//     backgroundColor: '#f0f0ff',
//   },
//   disabledRow: {
//     backgroundColor: '#f9f9f9',
//     color: '#999',
//     cursor: 'not-allowed',
//   },
//   tableCell: {
//     flex: 1,
//     padding: '0 5px',
//     display: 'flex',
//     alignItems: 'center',
//   },
//   checkbox: {
//     width: '16px',
//     height: '16px',
//     cursor: 'pointer',
//     margin: '0 auto',
//   },
//   zeroCount: {
//     color: 'red',
//     fontWeight: '600',
//   },
//   detailRow: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '10px 0',
//     borderBottom: '1px solid #f0f0f0',
//   },
//   detailLabel: {
//     fontWeight: '600',
//     color: '#555',
//   },
//   actionContainer: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     gap: '10px',
//     paddingTop: '15px',
//     marginTop: 'auto',
//   },
//   applyButton: {
//     padding: '10px 20px',
//     backgroundColor: '#6174DD',
//     color: 'white',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     fontSize: '16px',
//     transition: 'background-color 0.2s',
//     '&:hover': {
//       backgroundColor: '#4a5bc7',
//     },
//   },
//   removeButton: {
//     padding: '10px 20px',
//     backgroundColor: '#ff4444',
//     color: 'white',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     fontSize: '16px',
//     transition: 'background-color 0.2s',
//     '&:hover': {
//       backgroundColor: '#cc0000',
//     },
//   },
//   errorMessage: {
//     color: 'red',
//     marginRight: 'auto',
//     fontSize: '14px',
//   },
//   expiredText: {
//     color: 'red',
//     fontWeight: '600',
//   },
// };

// export default MembershipCard;
import React, { useEffect, useState } from 'react';
import { handleMembershipInputChange } from "../../redux/slices/billSlice";
import { useMain } from '../hooks/useMain';


import { Dialog, DialogActions, DialogContent, Button } from '@mui/material';
const MembershipCard = ({ data, state, dispatch, onClose, handleUpdateServices , client, onMembershipExtend}) => {
  const { extendMembership } = useMain();
  const [selectedServices, setSelectedServices] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedType, setSelectedType] = useState(null);
  const [serviceSelections, setServiceSelections] = useState({});
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [newEndDate, setNewEndDate] = useState('')

  const memberships = Array.isArray(data) ? data : [data];
  const hasServiceMembership = memberships.some(m => m.membershipType === 'serviceType');
  const hasDiscountMembership = memberships.some(m => m.membershipType === 'discountType');
  // Initialize selected services and service selections
  const filteredMemberships = selectedType
    ? memberships.filter(m => m.membershipType === selectedType)
    : [];

  useEffect(() => {
    if (selectedType === 'serviceType') {
      const servicesInBill = new Set(state.services.map(s => s.service));
      const initialSelections = {};
      let allSelected = [];

      memberships.forEach((membership, tabIndex) => {
        if (membership.membershipType === 'serviceType' && membership.services) {
          initialSelections[tabIndex] = membership.services
            .filter(service => servicesInBill.has(service.id))
            .map(service => service.id);

          membership.services.forEach(service => {
            if (servicesInBill.has(service.id) && !allSelected.some(s => s.id === service.id)) {
              allSelected.push(service);
            }
          });
        }
      });

      setServiceSelections({});
      setSelectedServices([]);
    }
  }, [selectedType, memberships, state.services]);

  const handleCheckboxChange = (service, tabIndex) => {
        if (isMembershipExpired || isMembershipFuture) return;
    const isSelected = serviceSelections[tabIndex]?.includes(service.id) || false;

    setServiceSelections(prev => {
      const newSelections = { ...prev };
      if (!newSelections[tabIndex]) newSelections[tabIndex] = [];

      if (isSelected) {
        newSelections[tabIndex] = newSelections[tabIndex].filter(id => id !== service.id);
      } else {
        newSelections[tabIndex] = [...newSelections[tabIndex], service.id];
      }
      return newSelections;
    });

    setSelectedServices(prev => {
      if (isSelected) {
        return prev.filter(item => item.id !== service.id);
      } else {
        const alreadyExists = prev.some(item => item.id === service.id);
        if (alreadyExists) return prev;
        return [...prev, service];
      }
    });
  };

  const applyHandler = () => {
    if (isMembershipExpired || isMembershipFuture) {
      return;
    }
    if (selectedType === 'discountType') {
      const activeMembership = memberships.find(m =>
        m.membershipType === 'discountType' && m._id === filteredMemberships[activeTab]?._id
      );
      console.log(activeMembership, 'activeMembership')
      if (activeMembership) {
        dispatch(handleMembershipInputChange({
          useMembership: true,
          item: activeMembership,
          selectedServices: [],
          membershipUniqueId: [activeMembership.membershipId?._id]
        }));
      }
    } else {
      // First get the active membership
      const activeMembership = filteredMemberships[activeTab];

      const updatedServices = selectedServices.map(service => {
        const matchedMembership = memberships.find(m =>
          m.membershipType === 'serviceType' &&
          m.services?.some(s => s.id === service.id)
        );

        return {
          serviceName: service.serviceName,
          service: service.id,
          category: service.category,
          quantity: 1,
          serviceProvider: [],
          price: service.price,
          discount: 100,
          discountType: '%',
          amount: 0,
          membershipApplied: true,
          membershipUniqueId: matchedMembership?.membershipId?._id || null,
        };
      });



      const uniqueMembershipIds = [...new Set(
        selectedServices.map(service => {
          const matchedMembership = memberships.find(m =>
            m.membershipType === 'serviceType' &&
            m.services?.some(s => s.id === service.id)
          );
          return matchedMembership?.membershipId?._id;
        }).filter(Boolean)
      )];


      if (activeMembership) {
        dispatch(handleMembershipInputChange({
          useMembership: true,
          item: activeMembership,
          selectedServices: updatedServices,
          membershipUniqueId: uniqueMembershipIds
        }));
        handleUpdateServices(updatedServices);
      }
    }
    onClose();
  };


  const removeHandler = () => {
    dispatch(handleMembershipInputChange({
      useMembership: false,
      item: null,
      selectedServices: []
    }));
    onClose();
  };

  const isServiceDisabled = (service) => {
    if (isMembershipExpired || isMembershipFuture) {
      return true;
    }
    return service.count === 0;
  };

  const calculateSubTotal = () => {
    return state.services.reduce((total, item) => total + (item.price * item.quantity), 0) +
      state.products.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const currentSubTotal = calculateSubTotal();
  const activeMembership = filteredMemberships[activeTab];

  // const canApplyDiscount = activeMembership?.membershipType === 'discountType' &&
  //   currentSubTotal >= (activeMembership?.discount?.minBillAmount || 0) &&
  //   (activeMembership?.discount?.availableCount || 0) > 0;

  // const canApplyDiscount = activeMembership?.membershipType === 'discountType' &&
  //   currentSubTotal >= (activeMembership?.discount?.minBillAmount || 0) &&
  //   (
  //     // Only check availableCount if it exists in the membership
  //     typeof activeMembership?.discount?.availableCount === 'undefined' ||
  //     (activeMembership?.discount?.availableCount || 0) > 0
  //   );

const isMembershipExpired = Boolean(
    activeMembership?.endDate && new Date(activeMembership.endDate) < new Date()
  );

  const isMembershipFuture = Boolean(
    activeMembership?.startDate && (() => {
      const startDate = new Date(activeMembership.startDate);
      if (isNaN(startDate.getTime())) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      return start > today;
    })()
  );

  const canApplyDiscount = !isMembershipFuture && !isMembershipExpired &&
    activeMembership?.membershipType === 'discountType' &&
    currentSubTotal > 0 && // Must have some services/products in bill
    currentSubTotal >= (activeMembership?.discount?.minBillAmount || 0) && // Must meet min bill amount
    (
      typeof activeMembership?.discount?.availableCount === 'undefined' || // Either availableCount doesn't exist
      activeMembership?.discount?.availableCount > 0 // Or it exists and has remaining uses
    );


  // Calculate selected services count per tab
  const getSelectedCountForTab = (tabIndex) => {
    return serviceSelections[tabIndex]?.length || 0;
  };

  // Calculate dynamic width based on view state
  const containerWidth = !selectedType ? '250px' : '500px';
  const containerHeight = !selectedType ? '230px' : 'auto';

  // Format date to DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return '';
     const cleanDate = typeof dateString === 'string' ? dateString.split('T')[0] : '';
    const parts = cleanDate.split('-');
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${day}-${month}-${year}`;
    }
    return dateString;
  };

  return (
    <div style={{
      ...styles.container,
      width: containerWidth,
      minHeight: containerHeight,
      maxHeight: selectedType ? '80vh' : '200px'
    }}>
      <div style={styles.header}>
        {selectedType && (
          <button onClick={() => setSelectedType(null)} style={styles.backButton}>
            ← Back
          </button>
        )}
        <h2 style={styles.title}>Membership Card</h2>
      </div>

      {!selectedType ? (
        <div style={styles.membershipTypeSelection}>
          {hasServiceMembership && (
            <button
              style={styles.membershipButton}
              onClick={() => setSelectedType('serviceType')}
            >
              Service Membership
            </button>
          )}

          {hasDiscountMembership && (
            <button
              style={{
                ...styles.membershipButton,
              }}
              onClick={() => setSelectedType('discountType')}
            >
              Discount Membership
            </button>
          )}
        </div>
      ) : (
        <div style={styles.membershipContent}>
          {filteredMemberships.length > 1 && (
            <div style={styles.tabContainer}>
              {filteredMemberships.map((membership, index) => (
                <button
                  key={membership._id}
                  style={{
                    ...styles.tabButton,
                    ...(activeTab === index && styles.activeTab)
                  }}
                  onClick={() => setActiveTab(index)}
                >
                  Membership {index + 1}
                  {selectedType === 'serviceType' && getSelectedCountForTab(index) > 0 && (
                    <span style={styles.badge}>
                      {getSelectedCountForTab(index)}
                    </span>
                  )}
                </button>
              ))}
            </div>
          )}

          <div style={styles.detailsContainer}>
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Membership Name :</span>
              <span>{activeMembership?.membershipId?.membershipName}</span>
            </div>
            {activeMembership?.startDate && (
              <div style={styles.detailRow}>
                <span style={styles.detailLabel}>Start Date:</span>
                <span style={isMembershipFuture ? styles.futureText : {}}>
                  {formatDate(activeMembership?.startDate)}
                  {isMembershipFuture && " (Upcoming)"}
                </span>
              </div>
            )}
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Valid Until:</span>
              <span style={isMembershipExpired ? styles.expiredText : {}}>
                {formatDate(activeMembership?.endDate)}
                {isMembershipExpired && " (Expired)"}
              </span>
            </div>

            {selectedType === 'discountType' ? (
              <>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Min. Bill Amount:</span>
                  <span>₹{activeMembership?.discount?.minBillAmount || 0}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Service Discount:</span>
                  <span>
                    {activeMembership?.discount?.discountOnService || 0}
                    {activeMembership?.discount?.serviceDiscountType || ''}
                  </span>
                </div>
                {
                  activeMembership?.discount?.availableCount !== undefined && (
                    <div style={styles.detailRow}>
                      <span style={styles.detailLabel}>Remaining Count:</span>
                      <span>{activeMembership?.discount?.availableCount || 0}</span>
                    </div>
                  )
                }
              </>
            ) : (
              <div style={styles.servicesContainer}>
                <div style={styles.tableHeader}>
                  <div style={{ ...styles.tableCell, flex: 0.5 }}>Select</div>
                  <div style={styles.tableCell}>Service</div>
                  <div style={styles.tableCell}>Category</div>
                  <div style={styles.tableCell}>Remaining</div>
                </div>
                <div style={styles.servicesTable}>
                  {activeMembership?.services?.map(service => (
                    <div
                      key={service.id}
                      style={{
                        ...styles.tableRow,
                        ...(isServiceDisabled(service) && styles.disabledRow),
                        ...(serviceSelections[activeTab]?.includes(service.id) && styles.selectedRow)
                      }}
                    >
                      <div style={{ ...styles.tableCell, flex: 0.5 }}>
                        <input
                          type="checkbox"
                          checked={serviceSelections[activeTab]?.includes(service.id) || false}
                          onChange={() => handleCheckboxChange(service, activeTab)}
                          disabled={isServiceDisabled(service)}
                          style={styles.checkbox}
                        />
                      </div>
                      <div style={styles.tableCell}>{service.serviceName}</div>
                      <div style={styles.tableCell}>{service.category}</div>
                      <div style={styles.tableCell}>
                        {service.count > 0 ? service.count : (
                          <span style={styles.zeroCount}>0</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div style={styles.actionContainer}>
            {isMembershipExpired ? (
<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={styles.errorMessage}>This membership has expired</div>
                <button
                  style={styles.applyButton}
                  onClick={() => setDatePickerOpen(true)}
                >
                  Extend Membership
                </button>
              </div>    
                ) : isMembershipFuture ? (
              <div style={styles.futureMessage}>
                Membership start date is {formatDate(activeMembership?.startDate)}, so you can avail from this date.
              </div>        
              ) : selectedType === 'discountType' ? (
              // First check if subtotal is 0 (no services/products in bill)
              data?.services?.length > 0 ? (
                <div style={styles.errorMessage}>  You need to add at least one service.</div>
              ) : (
                // Then check if minBillAmount condition is met
                currentSubTotal < (activeMembership?.discount?.minBillAmount || 0) ? (
                  <div style={styles.errorMessage}>
                    {`Add ₹${activeMembership?.discount?.minBillAmount - currentSubTotal} more to apply`}
                  </div>
                ) : (
                  // Then check availableCount only if it exists
                  typeof activeMembership?.discount?.availableCount !== 'undefined' ? (
                    activeMembership?.discount?.availableCount <= 0 ? (
                      <div style={styles.errorMessage}>You’ve used all your available counts.</div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <button style={styles.applyButton} onClick={applyHandler}>
                          Apply Discount
                        </button>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {activeMembership?.discount?.availableCount} uses remaining
                        </div>
                      </div>
                    )
                  ) : currentSubTotal > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <button style={styles.applyButton} onClick={applyHandler}>
                        Apply Discount
                      </button>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        Unlimited uses available
                      </div>
                    </div>
                  ) : (
                    <div style={styles.errorMessage}>
                       You need to add at least one service.
                    </div>
                  )

                )
              )
            ) : (
              selectedServices.length > 0 ? (
                <button style={styles.applyButton} onClick={applyHandler}>
                  Apply {selectedServices.length} Service{selectedServices.length !== 1 ? 's' : ''}
                </button>
              ) : (
                <div style={styles.errorMessage}>
                  {activeMembership?.services?.some(s => s.count > 0)
                    ? "Select services to apply"
                    : "No available services in this membership"}
                </div>
              )
            )}

            {state.useMembership && (
              <button style={styles.removeButton} onClick={removeHandler}>
                Remove Membership
              </button>
            )}
          </div>
        </div>
      )}
      <Dialog open={isDatePickerOpen} onClose={() => setDatePickerOpen(false)}>
        <DialogContent>
          <input
            type="date"
            value={newEndDate}
            onChange={(e) => setNewEndDate(e.target.value)}
            style={{ width: '100%', padding: '10px', fontSize: '16px' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDatePickerOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              await extendMembership(client._id, activeMembership.membershipId._id, newEndDate);
               if (onMembershipExtend) {
                onMembershipExtend();
              }
              setDatePickerOpen(false);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    borderRadius: '10px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    overflow: 'hidden',
    transition: 'all 0.3s ease'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '1px solid #eee',
    position: 'relative',
  },
  backButton: {
    background: 'none',
    border: 'none',
    color: '#6174DD',
    fontSize: '16px',
    cursor: 'pointer',
    padding: '5px 10px',
    marginRight: '10px',
  },
  title: {
    margin: 0,
    color: '#333',
    fontSize: '1.5rem',
  },
  membershipTypeSelection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '20px 0',
  },
  membershipButton: {
    padding: '15px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#6174DD',
    color: 'white',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    position: 'relative',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#4a5bc7',
    },
  },
  membershipContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
  },
  tabContainer: {
    display: 'flex',
    gap: '5px',
    marginBottom: '15px',
    overflowX: 'auto',
    padding: '5px 0',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      height: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#6174DD',
      borderRadius: '2px',
    },
  },
  tabButton: {
    padding: '8px 15px',
    borderRadius: '5px',
    border: '1px solid #ddd',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    position: 'relative',
  },
  activeTab: {
    backgroundColor: '#6174DD',
    color: 'white',
    borderColor: '#6174DD',
  },
  badge: {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    backgroundColor: '#ff4444',
    color: 'white',
    borderRadius: '50%',
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
  },
  detailsContainer: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  servicesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
    marginTop: '15px',
    border: '1px solid #eee',
    borderRadius: '8px',
  },
  tableHeader: {
    display: 'flex',
    backgroundColor: '#6174DD',
    color: 'white',
    padding: '12px 10px',
    fontWeight: '600',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  servicesTable: {
    flex: 1,
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#6174DD',
      borderRadius: '3px',
    },
  },
  tableRow: {
    display: 'flex',
    padding: '12px 10px',
    borderBottom: '1px solid #eee',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#f9f9f9',
    },
  },
  selectedRow: {
    backgroundColor: '#f0f0ff',
  },
  disabledRow: {
    backgroundColor: '#f9f9f9',
    color: '#999',
    cursor: 'not-allowed',
  },
  tableCell: {
    flex: 1,
    padding: '0 5px',
    display: 'flex',
    alignItems: 'center',
  },
  checkbox: {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
    margin: '0 auto',
  },
  zeroCount: {
    color: 'red',
    fontWeight: '600',
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid #f0f0f0',
  },
  detailLabel: {
    fontWeight: '600',
    color: '#555',
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '10px',
    paddingTop: '15px',
    marginTop: 'auto',
  },
  applyButton: {
    padding: '10px 20px',
    backgroundColor: '#6174DD',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#4a5bc7',
    },
  },
  removeButton: {
    padding: '10px 20px',
    backgroundColor: '#ff4444',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#cc0000',
    },
  },
  errorMessage: {
    color: 'red',
    marginRight: 'auto',
    fontSize: '14px',
  },
   futureMessage: {
    color: '#6274DD',
    backgroundColor: '#ffffff',
    border: '1px solid #000000',
    padding: '10px 14px',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: '500',
    width: '100%',
    textAlign: 'center',
    marginRight: 'auto',
  },
  futureText: {
    color: '#6274DD',
    fontWeight: '600',
  },
  expiredText: {
    color: 'red',
    fontWeight: '600',
  },
};

export default MembershipCard;